(ns practitest.frontend.users-view.project-groups
  (:require
    [practitest.frontend.common.i18n :refer [get-translation]]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.components.selector :as selector2]
    [practitest.frontend.components2.buttons :as buttons]
    [practitest.frontend.components2.misc-components :as misc-components]
    [practitest.frontend.users-view.events :as events]
    [practitest.frontend.users-view.subs :as users-view-subs]
    [re-frame.core :as re-frame]))

(defn- project-item [taken-ids {:keys [item] :as props}]
  (if (contains? taken-ids (:id item))
    [:div.selector-item.users-view-project-taken (:name item)]
    [selector2/default-selector-item props]))

(defn- project-select [idx project taken-ids projects]
  [selector2/new-select
   {:items projects
    :value project
    :label-fn :name
    :filterable? true
    :class "project-select"
    :placeholder (get-translation "users-view.project-groups.select-project" "Select project")
    :container (.-body js/document)
    :z-index 1060
    :selector-item-renderer (partial project-item taken-ids)
    :on-change (fn [selected]
                 (when-not (contains? taken-ids (:id selected))
                   (re-frame/dispatch [::events/select-project idx (:id selected)])))}])

(defn- groups-select [idx project group-ids]
  (let [group-ids (set group-ids)]
    [selector2/new-select
     {:items (:groups project)
      :value (filterv #(contains? group-ids (:id %)) (:groups project))
      :label-fn :name
      :multi? true
      :filterable? true
      :disabled? (nil? project)
      :class "groups-select"
      :placeholder (get-translation "users-view.project-groups.select-groups" "Select groups")
      :container (.-body js/document)
      :z-index 1060
      :on-change (fn [selected]
                   (re-frame/dispatch [::events/select-groups idx (map :id selected)]))}]))

(defn- project-group-line [idx {:keys [project-id group-ids]} projects taken-ids last? only?]
  (let [project (some #(when (= project-id (:id %)) %) projects)]
    [:div.project-group
     [:div.project-group-cell
      [project-select idx project (disj taken-ids project-id) projects]]
     [:div.project-group-cell
      [groups-select idx project group-ids]]
     [:div.project-group-actions
      [buttons/icon-button
       {:class "remove-project-group"
        :icon [icons/mux-x]
        :disabled? only?
        :on-click #(re-frame/dispatch [::events/remove-project-group idx])}]
      [misc-components/link-button
       {:class "add-project-group"
        :disabled? (not last?)
        :on-click #(when last? (re-frame/dispatch [::events/add-project-group]))}
       [icons/mux-plus-circle]
       (get-translation "users-view.project-groups.add-row" "Add Row")]]]))

(defn project-groups []
  (let [project-groups (:project-groups @(re-frame/subscribe [::users-view-subs/invite-form]))
        projects @(re-frame/subscribe [::users-view-subs/projects])
        taken-ids (set (keep :project-id project-groups))
        last-idx (dec (count project-groups))]
    [:div.project-groups
     [:div.project-groups-header
      [:span (get-translation "generic.label.project" "Project")]
      [:span (get-translation "generic.label.group" "Group")]]
     [:div.project-groups-lines
      (doall
        (map-indexed
          (fn [idx project-group]
            ^{:key idx}
            [project-group-line idx project-group projects taken-ids (= idx last-idx) (zero? last-idx)])
          project-groups))]]))
